import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginFormComponent} from './login/login-form/login-form.component';
import {HomeComponent} from './home/home.component';
import {AuthGuard, ProfileResolver} from 'shared';
import {UserDomainsResolver} from './user-domains/user-domains.resolver';
import {RecoveryFormComponent} from './login/recovery-form/recovery-form.component';
import {RecoveryChangePasswordFormComponent} from './login/recovery-change-password-form/recovery-change-password-form.component';
import {SettingsResolver} from './settings/settings.resolver';


const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    resolve: {
      settings: SettingsResolver,
      user: ProfileResolver,
      domains: UserDomainsResolver,
    },
    data: {supportImpersonate: true},
    children: [
      {
        path: '',
        component: HomeComponent,
      }
    ]
  },

  {path: 'login', component: LoginFormComponent},
  {path: 'recovery', component: RecoveryFormComponent},
  {path: 'recovery-change-password', component: RecoveryChangePasswordFormComponent},

  // Fallback when no prior routes is matched
  {path: '**', redirectTo: '', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
